"use client";
import { memo, type ReactElement } from "react";
import type { TeamCategory } from "@cabal/shared/domain/session/team/enums.js";
import { ColorType } from "@/theme/colors";
import { FontWeight } from "@/theme/typography";
import type { DataElScope } from "@/utils/dataEl";
import { Ccategoryicon } from "../Ccategoryicon";
import { Ctext } from "../Ctext";
import { CTEAMCARD_TEXT_CLAMP_STYLE, CTEAMCARD_TOP_ROW_STYLE, getCteamcardTitleMetrics, } from "./Cteamcard.styles";
interface CteamcardTitleRowProps {
    dataElScope: DataElScope;
    teamName: string;
    category?: TeamCategory;
    isMobile: boolean;
    priority: boolean;
}
export const CteamcardTitleRow = memo(function CteamcardTitleRow({ dataElScope, teamName, category, isMobile, priority, }: CteamcardTitleRowProps): ReactElement {
    const { titleFontSize, titlePaddingTop, categoryIconSize } = getCteamcardTitleMetrics({ isMobile });
    return <div style={CTEAMCARD_TOP_ROW_STYLE}>
            <Ctext color={ColorType.White} weight={FontWeight.Heavy} opacity={1} style={{
            ...CTEAMCARD_TEXT_CLAMP_STYLE,
            fontSize: titleFontSize,
            letterSpacing: "0.6px",
            paddingTop: titlePaddingTop,
        }}>
                {teamName}
            </Ctext>
            {category ? (<Ccategoryicon dataElScope={dataElScope} category={category} size={categoryIconSize} opacity={1} priority={priority}/>) : null}
        </div>
        ;
});
